// TODO: rewrite code without try/catch
/* eslint no-empty: 0 */
import _ from 'underscore';
import $ from 'jquery';
import Spinner from 'spin.js/spin.js';

import BaseButton from 'source/lib/component/button/base';

import template from './template.html';

let spinner;
let waitingLocked;

const ExternalAuthButton = BaseButton.extend({
    name: 'external-auth-button',
    defaultSpinnerOptions: {
        lines: 11, // The number of lines to draw
        length: 5, // The length of each line
        width: 2, // The line thickness
        radius: 5, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#fff', // #rgb or #rrggbb or array of colors
        speed: 1.1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        left: '22px', // Left position relative to parent
    },
    template,
    initialize(options) {
        BaseButton.prototype.initialize.call(this, options);
        this.service = this.data['external-service'];
        this.spinnerOptions = _.extend(this.defaultSpinnerOptions, options.spinnerOptions);
        this.bindElements();
    },
    events: {
        'mousedown .js-authentication-external-service': 'preventBlur',
        'click .js-authentication-external-service': 'select',
    },
    spinner() {
        spinner = spinner || new Spinner(this.spinnerOptions);
        return spinner;
    },
    bindElements() {
        const waitStartEvent = `component:${this.name}:${this.service}:wait-start`;
        const waitStopEvent = `component:${this.name}:wait-stop`;

        this.$a = this.$('.js-authentication-external-service');
        this.$li = this.$('.js-authentication-external-service-wrapper');
        this.$parent = this.$el.parent('.js-authentication-external-service-list');

        this.$parent.on(waitStopEvent, _.bind(this.stopSpinner, this));
        this.$parent.on(waitStartEvent, _.bind(this.initializeSpinner, this));
    },
    preventBlur(event) {
        /* eslint-disable max-len */
        // Prevents the focus from leaving the login/password input when clicking on the social network.
        // Result - layout does not shift ahead of time and the click works stably.
        event.preventDefault();
    },
    select(event) {
        if (waitingLocked) {
            this.components.proxyEvent('abort', event, this);
            this.stopSpinner();
            return false;
        }
        if (this.globalSubmitDisabled()) {
            return false;
        }
        waitingLocked = true;
        this.disable();
        this.initializeSpinner();
        this.components.proxyEvent('start', event, this);
        return false;
    },
    initializeSpinner() {
        try {
            this.$a.addClass(this.data['spinner-class']);
            this.spinner().spin(this.$a[0]);
            $(spinner.el).css('left', this.spinnerOptions.left);
            $(spinner.el).css('top', this.spinnerOptions.top);
        } catch (e) {

        }
    },
    stopSpinner() {
        waitingLocked = false;
        this.enable();
        try {
            this.spinner().stop();
            this.$a.removeClass(this.data['spinner-class']);
        } catch (e) {

        }
    },
});

export default ExternalAuthButton;
